import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Text } from '@notino/react-styleguide';

import { messages } from '../../../messages';

import { SLoyalty, SWrapper } from './styled';

export const BodyColumn = (text: React.ReactNode[]) => () => (
  <SWrapper>
    <Text typography="labelRegular">
      <FormattedMessage {...messages.loyaltyTitle} />
    </Text>
    <SLoyalty>{text}</SLoyalty>
  </SWrapper>
);
